export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создание виджета для"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отмена"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Счет"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сгенерировать"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оплата в"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сумма платежа"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Действия при успехе"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Действия при неуспехе"])}
}